/** Typed exactly, surrounding spaces aside. An empty phrase never matches. */
export function confirmPhraseMatches(typed: string, phrase: string): boolean {
  const wanted = phrase.trim();
  return wanted !== "" && typed.trim() === wanted;
}
